import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import HomePage from "./components/site/HomePage";
import LeadsPage from "./components/LeadsPage";
import { initializeAnalytics, trackPageView } from "./utils/analytics";

const RouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
};

const NaoEncontrada: React.FC = () => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-bone px-6 text-center">
    <p className="eyebrow">Erro 404</p>
    <h1 className="font-display text-display-sm font-bold text-soil">
      Esta página não existe
    </h1>
    <p className="max-w-sm text-base text-soil/70">
      O endereço pode ter mudado. Volte para a página inicial para continuar.
    </p>
    <a href="/" className="cta-solid mt-2">
      Ir para a página inicial
    </a>
  </div>
);

const App: React.FC = () => {
  useEffect(() => {
    initializeAnalytics();
  }, []);

  return (
    <Router>
      <div className="App font-inter">
        <RouteTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/leads" element={<LeadsPage />} />
          <Route path="*" element={<NaoEncontrada />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
